import {isPlainObject, isArray, each} from "lodash"
import {APIResponse} from "../../index"

export default (res: APIResponse): APIResponse => {
  if (res.config.isApolloQuery || res.config.isGraphQuery) {
    return res
  }

  if (shouldIterate(res.data)) {
    const Etag = getEtagFromResponse(res)
    addEtag(res.data, Etag)
  }

  return res
}

function addEtag(data: any, Etag: string = getEtag(data)) {
  if (isArray(data)) {
    each(data, (item) => addEtag(item))
  } else if (isPlainObject(data)) {
    data.Etag = Etag
    each(data, (item) => {
      if (shouldIterate(item)) addEtag(item)
    })
  }
}

function getEtag(item: any) {
  return item.etag || item.Etag
}

function getEtagFromResponse(res: APIResponse) {
  const etag = res.headers.etag
  const Etag = res.headers.Etag

  return getEtag(res.data) || etag || Etag
}

function shouldIterate(obj: any) {
  return isPlainObject(obj) || Array.isArray(obj)
}
